import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import TItemUtilidad from '../TItemUtilidad';
import { useDispatch } from 'react-redux';
import { obtenerItemsUtiliad } from "./../../../ducks/finanzasDuck"
import PickerMod from '../../../global/PickersMod';
import { FormatoFecha } from '../../../utils/FormatFecha';
import BackDrop from '../../../global/BackDrop';
const ItemsUtilidad = () => {
    const dispatch = useDispatch()
    const [selectDayInicio, setSelectedDateInicio] = useState(new Date());
    const [load, setLoad] = useState(false)
    useEffect(() => {
        setLoad(true)
        dispatch(obtenerItemsUtiliad({ fecha: FormatoFecha({ date: selectDayInicio, formato: "MMddyyyy" }) })).then(Response => {
            setLoad(false)
        })
        dispatch(obtenerItemsUtiliad({ fecha: FormatoFecha({ date: selectDayInicio, formato: "MMddyyyy" }) })).then(Response => {
            setLoad(false)
        })
    }, [dispatch, selectDayInicio])

    return (
        <div style={{marginTop: "2%"}}>
            <Grid container>
                <Grid item xs={4}>
                    <div style={{ paddingRight: "0" }}>
                        <PickerMod
                            id="fecha"
                            label="Fecha"
                            selectedDate={selectDayInicio}
                            setSelectedDate={setSelectedDateInicio}
                            disablePast={false}
                            disableFuture={false}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <TItemUtilidad />
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </div>
    )
}
export default ItemsUtilidad